function ensureAuthHeader(authHeader) {
    if (!authHeader) {
        throw new Error("Not authenticated. Please login first.");
    }
    return authHeader;
}
async function readErrorText(response) {
    try {
        return await response.text();
    }
    catch {
        return "";
    }
}
export function mapRagProgressStage(stage) {
    switch (stage) {
        case "embedding":
            return "embedding";
        case "finalizing":
            return "finalizing";
        case "batch":
            return "batch";
        case "complete":
            return "complete";
        case "error":
            return "error";
        default:
            return "uploading";
    }
}
export function extractFilenameFromPath(filepath) {
    if (!filepath)
        return "";
    const parts = filepath.split(/[/\\]/);
    return parts[parts.length - 1] || filepath;
}
export async function detectRagUploadConflicts(params) {
    const { baseUrl, files } = params;
    const authHeader = ensureAuthHeader(params.authHeader);
    const formData = new FormData();
    files.forEach((file) => {
        formData.append("files", file, file.name);
    });
    const response = await fetch(`${baseUrl}/rag/upload-phase1-detect`, {
        method: "POST",
        headers: {
            Authorization: authHeader,
        },
        body: formData,
    });
    if (!response.ok) {
        const errorText = await readErrorText(response);
        throw new Error(`Conflict detection failed: ${response.status} - ${errorText}`);
    }
    return (await response.json());
}
export async function commitRagUploads(params) {
    const { baseUrl, uploadId, decisions, workbookId } = params;
    const authHeader = ensureAuthHeader(params.authHeader);
    const response = await fetch(`${baseUrl}/rag/upload-phase2-commit`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: authHeader,
        },
        body: JSON.stringify({
            upload_id: uploadId,
            workbook_id: workbookId,
            decisions,
        }),
    });
    if (!response.ok) {
        const errorText = await readErrorText(response);
        throw new Error(`Upload commit failed: ${response.status} - ${errorText}`);
    }
    return (await response.json());
}
export async function cancelRagUploads(params) {
    const { baseUrl, filepaths } = params;
    const authHeader = ensureAuthHeader(params.authHeader);
    const response = await fetch(`${baseUrl}/rag/cancel-upload`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: authHeader,
        },
        body: JSON.stringify(filepaths),
    });
    if (!response.ok) {
        const errorText = await readErrorText(response);
        throw new Error(`Cancel failed: ${response.status} - ${errorText}`);
    }
}
export async function getIndexedRagFiles(params) {
    const response = await fetch(`${params.baseUrl}/rag/files`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            ...(params.authHeader ? { Authorization: params.authHeader } : {}),
        },
    });
    if (!response.ok) {
        throw new Error(`Failed to get files: ${response.status}`);
    }
    const payload = (await response.json());
    const files = payload.files || [];
    return files.map((file) => ({
        filepath: String(file.filepath || ""),
        filename: String(file.filename || ""),
        file_index: Number(file.file_index || -1),
        last_vectorized: String(file.last_vectorized || ""),
    }));
}
